var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var utils = require('../../../../utils/utils');
var NavListItem = require('./navListItem.jsx');

var NavList = createReactClass({
    mixins: [PureRenderMixin],

    $dashboardNavListWrapper: null,
    $dashboardNavList: null,
    hasScrollHandleInit: false,
    $scrollPrevHandle: null,
    $scrollNextHandle: null,
    scrollOffset: 180,

    componentDidMount: function(){
        this.$dashboardNavListWrapper = $('.dashboard-nav-list-wrapper');
        this.$dashboardNavList = $('.dashboard-nav-list');
        this.initScrollHandle();

        this.mediaqueryChangedHandler();
        $(window).on('changed.zf.mediaquery', this.mediaqueryChangedHandler);
    },

    componentDidUpdate: function(prevProps){
        this.locateChartContent();
    },

    componentWillUnmount: function(){
        $(window).off('changed.zf.mediaquery', this.mediaqueryChangedHandler);
        this.$dashboardNavListWrapper.off('click.dashboardNavScrollHandle');
    },

    initScrollHandle: function(){
        if(this.hasScrollHandleInit){
            this.updateScrollHandleVisibility();

            return;
        }

        var dashboardNavList = this.$dashboardNavList[0];

        if(dashboardNavList.offsetWidth !== dashboardNavList.scrollWidth){
            this.$dashboardNavListWrapper.prepend('<li class="scroll-prev-handle scroll-handle"><span class="ion-ios-arrow-back"></span></li><li class="scroll-next-handle scroll-handle"><span class="ion-ios-arrow-forward"></span></li>');

            this.$scrollPrevHandle = this.$dashboardNavListWrapper.find('.scroll-prev-handle');
            this.$scrollNextHandle = this.$dashboardNavListWrapper.find('.scroll-next-handle');
            this.hasScrollHandleInit = true;
            this.scrollOffset = this.$dashboardNavListWrapper.find('.nav-list-item').outerWidth();

            this.$dashboardNavListWrapper.on('click.dashboardNavScrollHandle', '.scroll-handle', function(e){
                if($(e.currentTarget).hasClass('scroll-next-handle')){
                    this.$dashboardNavList.stop().animate({scrollLeft: dashboardNavList.scrollLeft + 180}, this.updateScrollHandleVisibility);
                }else{
                    this.$dashboardNavList.stop().animate({scrollLeft: dashboardNavList.scrollLeft - 180}, this.updateScrollHandleVisibility);
                }
            }.bind(this));

            this.$dashboardNavListWrapper.on('click.dashboardNavListItem', '.nav-list-item', function(e){
                var $currentTarget = $(e.currentTarget);

                if($currentTarget.position().left < 0){
                    this.$scrollPrevHandle.click();
                }else if($currentTarget.position().left + 180 > dashboardNavList.offsetWidth){
                    this.$scrollNextHandle.click();
                }
            }.bind(this));
        }

        this.updateScrollHandleVisibility();
    },

    updateScrollHandleVisibility: function(){
        if(!this.hasScrollHandleInit){
            return;
        }

        var dashboardNavList = this.$dashboardNavList[0];

        if(dashboardNavList.offsetWidth === dashboardNavList.scrollWidth){
            this.$dashboardNavListWrapper.removeClass('show-scroll-prev-handle show-scroll-next-handle');
            return;
        }

        if(dashboardNavList.scrollLeft > 0){
            this.$dashboardNavListWrapper.addClass('show-scroll-prev-handle');
        }else{
            this.$dashboardNavListWrapper.removeClass('show-scroll-prev-handle');
        }

        if(dashboardNavList.scrollLeft < dashboardNavList.scrollWidth - dashboardNavList.offsetWidth){
            this.$dashboardNavListWrapper.addClass('show-scroll-next-handle');
        }else{
            this.$dashboardNavListWrapper.removeClass('show-scroll-next-handle');
        }
    },

    mediaqueryChangedHandler: function(){
        this.locateChartContent();
        this.initScrollHandle();
    },

    locateChartContent: function(){
        if(utils.isSmallScreen()
            && !this.props.isSnapShot
            && this.props.activeItems.length === 1){
                this.locateChartContentInLi();
        }else{
            this.locateChartContentInWrapper();
        }
    },

    locateChartContentInLi: function(){
        var $li = $('[id="' + 'nav-list-item-' + this.props.activeItems[0].id + '"]'); // eslint-disable-line
        if($li.find('#chartContent').length === 0){
            $li.append($('#chartContent'));
            this.clearItemNamesBackground();
            $li.find('.item-name').css('background', $li.css('border-left-color'));
        }
    },

    locateChartContentInWrapper: function(){
        if($('#chartContentWrapper #chartContent').length === 0){
            this.clearItemNamesBackground();
            $('#chartContentWrapper').append($('#chartContent'));
        }
    },

    clearItemNamesBackground: function(){
        $('.dashboard-nav-list .item-name').css('background', 'none');
    },

    render: function(){
        var navListItemNodes = this.props.scoreItems.map(function(scoreItem, idx){
            var isActive = false;
            var isHighlight = false;

            for(var i = 0; i < this.props.activeItems.length; i++){
                if(scoreItem.item.id === this.props.activeItems[i].id){
                    isActive = true;
                    break;
                }
            }

            if(this.props.isSnapShot && isActive){
                isActive = false;
                isHighlight = true;
            }else{
                isHighlight = isActive;
            }

            return (
                <NavListItem
                    key={idx}
                    id={'nav-list-item-' + scoreItem.item.id}
                    scoreItem={scoreItem}
                    isHighlight={isHighlight}
                    isActive={isActive}
                    addActiveItem={this.props.addActiveItem}
                    removeActiveItem={this.props.removeActiveItem}
                    id2ItemScoresData={this.props.id2ItemScoresData}
                    clickTracking={this.props.clickTracking} />
            );
        }.bind(this));

        return (
            <div className="dashboard-nav-list-wrapper">
                <ul className="dashboard-nav-list no-bullet">
                    {navListItemNodes}
                </ul>
            </div>
        )
    }
});

module.exports = NavList;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/layout/navList.jsx